// extracted by mini-css-extract-plugin
module.exports = {"urlBar":"UrlBar_urlBar__BsCpC","urlFieldWrapper":"UrlBar_urlFieldWrapper__1FbAx","urlField":"UrlBar_urlField__3VMsD"};